import { createWebHistory, createRouter } from 'vue-router';
import { authService } from '@services';

import error from './error/error.routes';
import login from './login/login.routes';
import dashboard from './dashboard/dashboard.routes';
import admin from './admin/admin.routes';
import me from './me/me.routes';
import entrepreneur from './entrepreneur/entrepreneur.routes';
import regulator from './regulator/regulator.routes';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...login,
    ...dashboard,
    ...admin,
    ...me,
    ...error,
    ...entrepreneur,
    ...regulator,
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => !record.meta.isPublic)) {
    if (!authService.hasToken()) {
      next({ name: 'Login' });
      return;
    }
  }
  next();
});

const DEFAULT_TITLE = 'Doc X Flow';
router.afterEach((to) => {
  document.title = to.meta?.title?.concat(' | ', DEFAULT_TITLE) || DEFAULT_TITLE;
});

export default router;
